__turbopack_context__.v({
  "app_light_theme": "messege-input-module-scss-module__xA1BEq__app_light_theme",
  "button": "messege-input-module-scss-module__xA1BEq__button",
  "inputArea": "messege-input-module-scss-module__xA1BEq__inputArea",
  "not_active_content": "messege-input-module-scss-module__xA1BEq__not_active_content",
  "not_active_text": "messege-input-module-scss-module__xA1BEq__not_active_text",
  "textarea": "messege-input-module-scss-module__xA1BEq__textarea",
});
